export default "__VITE_PUBLIC_ASSET__38ccf267__"